<script>
export default {
  name: 'CpCampaignTool',
  components: {
    CpButtonLink: require('../../button-link').default,
  },
  directives: {
    margin: require('../../directives/margins').margin,
    marginTop: require('../../directives/margins').marginTop,
    marginRight: require('../../directives/margins').marginRight,
    marginBottom: require('../../directives/margins').marginBottom,
    marginLeft: require('../../directives/margins').marginLeft,
  },
  props: {
    official: Object,
  },
  data() {
    return {
      campaignUrl: this.official?.crowdblue_campaign_page?.permalink ?? this.official.official_campaign_page ?? null,
    };
  },
};
</script>

<template>
  <div class="campaignToolContainer">
    <div class="lawmakerContainer">
      <i class="fal fa-podium fa-2x primary-color" v-margin-right="0.5"></i>
      <span>
        <h3 class="buttons primary-color" v-margin="0">{{ official.full_name }}</h3>
        <p class="body primary-color" v-margin="0">is running for election</p>
      </span>
    </div>
    <div class="buttons">
      <CpButtonLink v-if="campaignUrl" :href="campaignUrl" openExternally primary :block="$root.isPhone" v-margin-right="0.5">Visit Campaign Page</CpButtonLink>
      <CpButtonLink v-if="official?.crowdblue_campaign_page" :href="official.crowdblue_campaign_page.donate_url" openExternally link :block="$root.isPhone"
        >Donate</CpButtonLink
      >
    </div>
  </div>
</template>

<style scoped>
.campaignToolContainer,
.lawmakerContainer,
.buttons {
  display: flex;
  align-items: center;
}
.campaignToolContainer {
  justify-content: space-between;
  background-color: var(--primary-blue-50);
  padding: 16px 24px;
  border-radius: 6px;
}
@media screen and (max-width: 500px) {
  .campaignToolContainer {
    flex-direction: column;
    align-items: flex-start;
  }
  .lawmakerContainer {
    margin-bottom: 10px;
  }
  .buttons {
    width: 100%;
  }
}
@media screen and (max-width: 414px) {
  .buttons {
    flex-direction: column;
    align-items: center;
  }
  .buttons a:first-child {
    margin-bottom: 10px;
  }
}
</style>
